<template>
  <v-container fluid pa-0>
    <v-row align="center" class="mb-5" justify="center" no-gutters>
          <span>
            <v-icon class="mr-2">mdi-thumb-up</v-icon>
            {{fields[0].text}}
          </span>
      <span class="px-2"><b>{{$t('general.and')}}</b></span>
      <span>
            {{fields[1].text}}
            <v-icon class="ml-2">mdi-thumb-down</v-icon>
          </span>
    </v-row>
    <div v-if="innerValue">
      <v-row :key="option.id"
             no-gutters
             class="flex-nowrap flex-grow-1"
             justify="center"
             v-for="(option) in options"
      >
        <v-col cols="auto" style="display: flex; align-items: center;">
            <v-checkbox :false-value="null"
                        :input-value="innerValue[fields[0].fieldid]"
                        :true-value="option.id"
                        :value="innerValue[fields[0].fieldid]"
                        @change="setSelection(fields[0].fieldid, fields[1].fieldid, $event, 'left')"
                        off-icon="mdi-thumb-up-outline"
                        on-icon="mdi-thumb-up"
            ></v-checkbox>
        </v-col>
        <v-col cols="auto" class="px-0" style="padding: 10px 60px 10px 55px; min-width: 350px; max-width: 350px;">
          <v-row align="center" justify="center">
            <v-card :class="{ 'grow-option-card': currentEvents.includes(option.start_event), 'shrink-option-card': !currentEvents.includes(option.start_event) }"
                    :id="'option_card_'+option.id"
                    :style="{ 'background-color': (Object.values(innerValue).includes(option.id) ? 'white' : '#809BB1') }"
                    class="d-flex animate-changes"
                    light
                    min-height="60"
                    style="border-radius: 20px; z-index: 1; user-select: none;"
                    width="250"
            >
              <v-card-text>
                <v-row align="center"
                       class="fill-height"
                       justify="center"
                       no-gutters
                >
                  <div class="text-wrap"
                       style="line-height: 1.2; color: black !important; font-size: 12px;"
                  >{{ option.text }}
                  </div>
                </v-row>
              </v-card-text>
            </v-card>
            <v-card :id="'card_track_'+option.id"
                    :style="{ 'background-color': (Object.values(innerValue).includes(option.id) ? 'rgba(255,255,255,0.3)' : 'rgba(255,255,255,0.1)') }"
                    :width="(250)*1.2"
                    class="animate-changes"
                    elevation="0"
                    height="40"
                    style="border-radius: 20px; position: absolute; z-index: 0;"
            ></v-card>
          </v-row>
        </v-col>
        <v-col cols="auto" style="display: flex; align-items: center;">
            <v-checkbox :false-value="null"
                        :input-value="innerValue[fields[1].fieldid]"
                        :true-value="option.id"
                        :value="innerValue[fields[1].fieldid]"
                        @change="setSelection(fields[0].fieldid, fields[1].fieldid, $event, 'right')"
                        off-icon="mdi-thumb-down-outline"
                        on-icon="mdi-thumb-down"
            ></v-checkbox>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
    import {TweenMax} from 'gsap';
    import ApplicationEventHub from '../../../../../../events/applicationEventHub';

    export default {
        name: "Ipsative",
        props: {
            options: {
                required: true,
                type: Array
            },
            fields: {
                required: true,
                type: Array
            },
            value: {
                required: true,
            }
        },
        computed: {
            isRtl() {
                return this.$vuetify.rtl;
            }
        },
        data: () => ({
            innerValue: null,
            currentEvents: []
        }),
        methods: {
            cloneInner() {
                this.innerValue = JSON.parse(JSON.stringify(this.value || {}));
            },
            setSelection(fieldLeft, fieldRight, event, side) {
                if (side === 'left') {
                    this.tweenSelectionCard(fieldLeft, '0');
                    this.$set(this.innerValue, [fieldLeft], event);
                    if(this.isRtl) {
                        this.tweenSelectionCard(fieldLeft, '35px');
                    } else {
                        this.tweenSelectionCard(fieldLeft, '-35px');
                    }
                    if (this.innerValue[fieldRight] === event) {
                        this.$set(this.innerValue, fieldRight, null);
                    }
                } else if (side === 'right') {
                    this.tweenSelectionCard(fieldRight, '0');
                    this.$set(this.innerValue, [fieldRight], event);
                    if(this.isRtl) {
                        this.tweenSelectionCard(fieldRight, '-35px');
                    } else {
                        this.tweenSelectionCard(fieldRight, '35px');
                    }
                    if (this.innerValue[fieldLeft] === event) {
                        this.$set(this.innerValue, fieldLeft, null);
                    }
                }
                const temp = JSON.stringify(this.innerValue);
                if (temp !== JSON.stringify(this.value)) {
                    this.$emit('input', JSON.parse(temp));
                }
            },
            tweenSelectionCard(field, amount, duration = 0) {
                if(this.innerValue[field] !== null) {
                    TweenMax.to('#option_card_' + this.innerValue[field], duration, {
                        css: {
                            'transform': `translateX(${amount})`
                        }
                    });
                }
            },
            setInitialState() {
                let foundLeft = Object.keys(this.innerValue).find(k => parseInt(k) === this.fields[0].fieldid),
                    foundRight = Object.keys(this.innerValue).find(k => parseInt(k) === this.fields[1].fieldid);
                this.$nextTick(() => {
                    if (foundLeft !== null) {

                      if(this.isRtl) {
                        this.tweenSelectionCard(parseInt(foundLeft), '35px',0);
                      } else {
                        this.tweenSelectionCard(parseInt(foundLeft), '-35px',0);
                      }

                        // this.tweenSelectionCard(parseInt(foundLeft), '-35px', 0);
                    }
                    if (foundRight !== null) {
                      if(this.isRtl) {
                        this.tweenSelectionCard(parseInt(foundRight), '-35px',0);
                      } else {
                        this.tweenSelectionCard(parseInt(foundRight), '35px',0);
                      }

                        // this.tweenSelectionCard(parseInt(foundRight), '35px', 0);
                    }
                });
            },
            mediaEventListeners() {
                ApplicationEventHub.$on('eventStarted', this.growOnEvent);
                ApplicationEventHub.$on('eventEnded', this.shrinkOnEvent);
                ApplicationEventHub.$on('endAllEvents', this.endAll);
            },
            growOnEvent(event) {
                this.currentEvents.indexOf(event) === -1 && this.currentEvents.push(event);
            },
            shrinkOnEvent(event) {
                let index = this.currentEvents.findIndex(e => e === event);
                this.$delete(this.currentEvents, index);
            },
            endAll() {
                this.currentEvents = [];
            }
        },
        mounted() {
            this.cloneInner();
            this.$nextTick(() => {
                this.setInitialState();
            });
            this.mediaEventListeners();
            this.$watch('value', () => {
                this.cloneInner();
            }, {deep: true});
        },
        beforeDestroy() {
            this.innerValue = null;
            ApplicationEventHub.$off('eventStarted');
            ApplicationEventHub.$off('eventEnded');
            ApplicationEventHub.$off('endAllEvents');
        },
    }
</script>

<style scoped>
  .animate-changes {
    transition: background-color 0.4s ease;
  }

  .grow-option-card {
    transition: all 0.2s ease-in-out;
    transform: scale(1.1);
  }

  .shrink-option-card {
    transition: all 0.2s ease-in-out;
    transform: scale(1);
  }
</style>
